import React from "react";
import {
  ChipIcon,
  TechnologiesContainer,
  TechnologiesGrid,
  TechnologiesHeader,
  TechnologiesIntro,
  TechnologiesSubheader,
  TechnologyBadge,
  TechnologyCard,
  TechnologyMeta,
  TechnologyName,
  ToolsetChip,
  ToolsetDescription,
  ToolsetHeader,
  ToolsetRow,
  ToolsetWrapper,
} from "../../Styled/Skill/Skill.styled";

function Skill() {
  const icons = {
    firebase: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
    figma: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
    git: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    google: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg",
    mongodb: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    node: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    npm: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg",
    redux: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
    express: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
    canva: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg",
    vscode: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
    html5: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    css3: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
    javascript:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    reactjs: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    bootstrap: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
    tailwindcss:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original-wordmark.svg",
    nextjs: "https://cdn.simpleicons.org/nextdotjs/FFFFFF",
  };

  const featuredStack = [
    { id: "html5", icon: icons.html5, name: "HTML5", meta: "Markup" },
    { id: "css3", icon: icons.css3, name: "CSS3", meta: "Responsive UI" },
    { id: "javascript", icon: icons.javascript, name: "JavaScript", meta: "ES6+" },
    { id: "react", icon: icons.reactjs, name: "React", meta: "SPA & hooks" },
    { id: "next", icon: icons.nextjs, name: "Next.js", meta: "SSR / SSG" },
    { id: "tailwind", icon: icons.tailwindcss, name: "TailwindCSS", meta: "Utility-first" },
    { id: "node", icon: icons.node, name: "Node.js", meta: "API layer" },
    { id: "express", icon: icons.express, name: "Express", meta: "REST APIs" },
    { id: "mongodb", icon: icons.mongodb, name: "MongoDB", meta: "Document DB" },
    { id: "firebase", icon: icons.firebase, name: "Firebase", meta: "Auth & hosting" },
    { id: "redux", icon: icons.redux, name: "Redux", meta: "State orchestration" },
    { id: "git", icon: icons.git, name: "Git", meta: "Version control" },
    { id: "vscode", icon: icons.vscode, name: "VS Code", meta: "Primary IDE" },
    { id: "figma", icon: icons.figma, name: "Figma", meta: "Hand-off ready" },
    { id: "canva", icon: icons.canva, name: "Canva", meta: "Brand assets" },
    { id: "npm", icon: icons.npm, name: "NPM", meta: "Package tooling" },
    { id: "google", icon: icons.google, name: "Google Cloud", meta: "Workspace ops" },
  ];

  const aiTooling = [
    {
      id: "gemini",
      name: "Google Gemini",
      icon: "https://cdn.simpleicons.org/googlegemini/8ab4f8",
    },
    {
      id: "chatgpt",
      name: "ChatGPT",
      icon: "https://cdn.simpleicons.org/openai/74aa9c",
    },
    {
      id: "cursor",
      name: "Cursor",
      icon: "https://cdn.simpleicons.org/cursor/6366f1",
    },
    {
      id: "claude",
      name: "Claude",
      icon: "https://cdn.simpleicons.org/anthropic/ff4f00",
    },
    {
      id: "trae",
      name: "Trae AI",
      text: "Træ",
    },
  ];

  return (
    <TechnologiesContainer id="skill">
      <TechnologiesIntro>
        <TechnologiesHeader>Technologies I am familiar with</TechnologiesHeader>
        <TechnologiesSubheader>
          A curated stack used across production-grade MERN applications, design systems, and CMS
          builds. Everything ships performance-tested, accessible, and automation-ready.
        </TechnologiesSubheader>
      </TechnologiesIntro>

      <TechnologiesGrid>
        {featuredStack.map((tech) => (
          <TechnologyCard key={tech.id}>
            <TechnologyBadge>
              {tech.icon ? <img src={tech.icon} alt={tech.name} loading="lazy" /> : <span>{tech.name.charAt(0)}</span>}
            </TechnologyBadge>
            <TechnologyName>{tech.name}</TechnologyName>
            <TechnologyMeta>{tech.meta}</TechnologyMeta>
          </TechnologyCard>
        ))}
      </TechnologiesGrid>

      <ToolsetWrapper>
        <ToolsetHeader>AI copilots & productivity</ToolsetHeader>
        <ToolsetDescription>
          Leveraging industry-leading AI assistants for code generation, QA, documentation, and site
          operations.
        </ToolsetDescription>
        <ToolsetRow>
          {aiTooling.map((tool) => (
            <ToolsetChip key={tool.id}>
              <ChipIcon>
                {tool.icon ? (
                  <img src={tool.icon} alt={tool.name} loading="lazy" />
                ) : (
                  <span>{tool.text}</span>
                )}
              </ChipIcon>
              {tool.name}
            </ToolsetChip>
          ))}
        </ToolsetRow>
      </ToolsetWrapper>
    </TechnologiesContainer>
  );
}

export default Skill;